import React from 'react';
import { Link } from 'react-router-dom';

export default class Assessments extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Assessments</h3>
      <h3 className="subtitle">Update an Assessment</h3>
      <p>This section covers how to update an assessment for a visit</p>
      <p>Assessments are nested resources and must be updated using the patient id, visit order and assessment id</p>

      <h3 className="subtitle">HTTP Request</h3>
      <p><code>GET https://api.ccihub.com/api/patients/{`{patient_id}`}/visits/{`{order}`}/assessments/{`{scale_id}`}</code></p>
      
      <h3 className="subtitle">Request Parameters</h3>
      <table className="table">
        <thead>
          <th>Parameter</th>
          <th>Required</th>
          <th>Type</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>patient_id</td>
            <td>yes</td>
            <td>string</td>
            <td>The id of the patient</td>
          </tr>
          <tr>
            <td>order</td>
            <td>yes</td>
            <td>number</td>
            <td>The order of the visit</td>
          </tr>
          <tr>
            <td>scale_id</td>
            <td>yes</td>
            <td>number</td>
            <td>The scale id of the assessment</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Assessment Request Payload</h3>
      <p>An assessment patch request can include any of the properties shown below:</p>
      <p>Unsupported properties in the payload will be discarded</p>
      <div className="code-snippet">
<pre><code>
{`{
  assessment: {
    finish: 'yyyy-mm-ddThh:mm:ss.ffffff',
    start: 'yyyy-mm-ddThh:mm:ss.ffffff'
  }
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Response</h3>
      <p>Returns the updated assessment resource</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Assessments.js